import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

const upcomingDeliveries = [
  { po: 'PO1023', item: 'Carmozyme 250mg', qty: 200, delivery: '22 Aug 2026', status: 'pending' },
  { po: 'PO1032', item: 'Ayurvedic Tonic', qty: 80, delivery: '28 Aug 2026', status: 'pending' },
  { po: 'PO1019', item: 'Analgesic Syrup', qty: 150, delivery: '20 Aug 2026', status: 'transit' },
];

const deliveryStatusColors = {
  pending: 'amber',
  transit: 'blue',
  delivered: 'green',
  cancelled: 'red',
};

export default function UpcomingDeliveriesCard() {
  return (
    <Box className="card" style={{ minHeight: '300px' }}>
      <div className="card-head">
        <h3 className="card-title">Upcoming Deliveries</h3>
      </div>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>PO Number</TableCell>
              <TableCell>Item</TableCell>
              <TableCell align="right">Qty</TableCell>
              <TableCell align="right">Delivery Date</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody id="vendUpcomingBody">
            {upcomingDeliveries.map((row) => (
              <TableRow key={row.po} hover>
                <TableCell>{row.po}</TableCell>
                <TableCell>{row.item}</TableCell>
                <TableCell align="right">{row.qty}</TableCell>
                <TableCell align="right">{row.delivery}</TableCell>
                <TableCell>
                  <span className={`pill ${deliveryStatusColors[row.status]}`}>
                    {row.status.charAt(0).toUpperCase() + row.status.slice(1)}
                  </span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
